import { lazy } from "react";

import Loadable from "../components/Loadable";
import LoginLayout from "../layout/login-layout";
import GuestGuard from "../utils/route-guard/guest-guard";

import type { RouteObject } from "react-router-dom";

const AuthLogin = Loadable(lazy(() => import("../views/authentication")));
const AuthForgotPassword = Loadable(
  lazy(() => import("../views/authentication/forget-password"))
);
const ResetPassword = Loadable(
  lazy(() => import("../views/authentication/reset-password"))
);

const loginRoutes: RouteObject[] = [
  {
    path: "/",
    element: (
      <GuestGuard>
        <LoginLayout />
      </GuestGuard>
    ),
    children: [
      {
        path: "/",
        element: <AuthLogin />,
      },
      {
        path: "/login",
        element: <AuthLogin />,
      },
      { path: "/forgot-password", element: <AuthForgotPassword /> },
      { path: "/reset-password", element: <ResetPassword /> },
    ],
  },
];

export default loginRoutes;
